export default __webpack_public_path__ + "static/media/aditi.ce6fffb2.jpeg";